import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../../sectionTitle/SectionTitle2'

const AISolutions = () => {
  return (
    <>
      <Element
        name="AISolutions"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Key Focus Areas"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Our platform combines cloud and edge AI to support clinicians, researchers, and health tech innovators in deploying intelligent, privacy-preserving, and real-time solutions.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} alt="gear" />
                </div>
                <h5 className="mt-3 mb-3">AI-Driven Accessibility Tools</h5>
                <p className="mb-0">Speech recognition and real-time autocorrection systems to support individuals with communication impairments.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/eye.svg`} alt="eye" />
                </div>
                <h5 className="mt-3 mb-3">Personalized Patient Monitoring</h5>
                <p className="mb-0">AI models that interpret biometric and behavioral data for anomaly detection and remote diagnostics.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/no-axis-columns-increasing.svg`} alt="no-axis-columns-increasing" />
                </div>
                <h5 className="mt-3 mb-3">Edge-Based Clinical Decision Support</h5>
                <p className="mb-0">Embedded systems for on-site inference and triage recommendations where latency and privacy matter.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">Medical Imaging & Signal Analysis</h5>
                <p className="mb-0">ML models for image segmentation, diagnostics, and analysis of complex biosignals like ECG/EEG.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/chart.svg`} alt="chart" />
                </div>
                <h5 className="mt-3 mb-3">Chronic Condition Management</h5>
                <p className="mb-0">Predictive tools for proactive care in diabetes, hypertension, and neurological disorders.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/shield-check.svg`} alt="shield-check" />
                </div>
                <h5 className="mt-3 mb-3">AI-Powered Health Apps & APIs</h5>
                <p className="mb-0">End-to-end pipeline support for health startups integrating NLP, vision, and recommendation engines.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AISolutions;